import { useRef, useState } from 'react'
import imageOne from '../../../assets/images/slider/slider-1.png'
import './Slider.scss'

const externalImages = [
]

const images = [imageOne, ...externalImages]

const Slider = () => {
  const [current, setCurrent] = useState(0)
  const [fadeState, setFadeState] = useState('')
  const [isTransitioning, setIsTransitioning] = useState(false)
  const nextIndexRef = useRef(null)

  const goToSlide = (newIndex) => {
    if (isTransitioning || newIndex === current) return
    setIsTransitioning(true)
    setFadeState('slider-fade-exit-active')
    nextIndexRef.current = newIndex
    setTimeout(() => {
      setCurrent(nextIndexRef.current)
      setFadeState('slider-fade-enter-active')
      setTimeout(() => {
        setFadeState('')
        setIsTransitioning(false)
      }, 200)
    }, 200)
  }

  const nextSlide = () => goToSlide((current + 1) % images.length)
  const prevSlide = () => goToSlide((current - 1 + images.length) % images.length)

  return (
    <div className="slider-bg">
      <div className="slider-container">
        {images.length > 1 && (
          <button className="slider-arrow right" aria-label="Anterior" onClick={prevSlide} disabled={isTransitioning}>
            <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 0 1024 1024" style={{ transform: 'rotate(180deg)' }}><path fill="#FF5959" d="M609.408 149.376L277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0a30.59 30.59 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.59 30.59 0 0 0 0-42.688a29.12 29.12 0 0 0-41.728 0" /></svg>
          </button>
        )}
        <div className="slider-center-image">
          <img
            src={images[current]}
            alt={`Slider ${current + 1}`}
            className={fadeState}
          />
        </div>
        {images.length > 1 && (
          <button className="slider-arrow left" aria-label="Próximo" onClick={nextSlide} disabled={isTransitioning}>
            <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 0 1024 1024"><path fill="#FF5959" d="M609.408 149.376L277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0a30.59 30.59 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.59 30.59 0 0 0 0-42.688a29.12 29.12 0 0 0-41.728 0" /></svg>
          </button>
        )}
      </div>
    </div>
  )
}

export default Slider
